import Axios from 'axios'
import API from './api'
import { Toast } from 'antd-mobile'

const DOMAIN = {
  java: {},
  php: {
    1: 'https://test2-motorrwa.mamobility.com/',
    2: 'https://mo-motorrwa.renewalasia.com/'
  }
}

const http = (url, params, method, hObjs) => {
  let { httpType, loading, hideload, lan } = hObjs;
  let _url = `${DOMAIN[httpType][process.env.BUILD_ENV]}${url}`;
  let _opts = method == "post" ? params : { params };
  let _token = window.localStorage.getItem('token') || '';
  const config = {
    timeout: 20000,
    headers: { 
    "Content-type": method=='post' ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded;',
    'Accept-Language': lan,
    'token': _token,
    'client': 'h5',
  }}
  const instance = Axios.create(config);   //重新初始化

  if (loading) showLoading(loading);
  
  return new Promise((resolve, reject) => {
    instance[method](_url, _opts, config).then(res => {
      if (loading && hideload) hideLoading();
      let _data = res.data || {};
      _data.code == 0 ? resolve(_data) : errHandle(res, resolve, hObjs);
    })
    .catch(res => {
      if (loading && hideload) hideLoading();
      errHandle(res, resolve, hObjs);
    })
  })
}

const errHandle = (res={}, resolve, hObjs) => {   //错误提示处理
  let { data, response } = res, { code, message } = data||response?.data||{}, { cusMsg, cusErr } = hObjs;
  if (!cusMsg) Toast.show(message || "网络状态异常~");
  if (res.status==401 || code==401){
    window.location.replace('/login');
    return;
  }
  if (cusErr) resolve(res.data);
}

export const showLoading = (loading) => {   //给body加上标签，其所子元素不允许点击
  document.body.setAttribute('class', 'antd-toast--unclickable');
  Toast.show({ maskClassName: 'cus-loading-wrap', content: typeof loading == 'string' ? loading : '加载中...', duration: 0, icon: 'loading' });
}

export const hideLoading = () => {
  document.body.setAttribute('class', '');
  Toast.clear();
}


/*
*  url: 接口名称简称
*  params: 参数
*  loading: 是否需要loading
*  cusErr: 是否自定义处理错误
*  cusMsg: 是否自定义弹出错误提示
*  httpType: 后端语言类型 java / php
*  hideload: 是否需要关闭loading
*  lan: 语言类型 zh(中文) / en(英语) / th(泰语) / zh-mo(澳门) / zh-hk(香港) / zh_TW(台湾)
*/
export const POST = (url, data={}, loading=true, cusErr=false, { cusMsg=false, httpType='php', hideload=true, lan='zh' }={}) => {
  return http(API[url], data, 'post', { loading, cusErr, cusMsg, httpType, hideload, lan });
}

export const GET = (url, data={}, loading=true, cusErr=false, { cusMsg=false, httpType='php', hideload=true, lan='zh' }={}) => {
  return http(API[url], data, 'get', { loading, cusErr, cusMsg, httpType, hideload, lan });
}